(function () {
  "use strict";

  var STORAGE_KEY = "ttCustomerFactsPending";
  var MANUAL_CUSTOMER_ID_KEY = "ttCustomerFactsCustomerId";
  var POPUP_SHOWN_KEY_PREFIX = "ttCustomerFactsPopupShown:";
  var ALLOWED_GENDERS = ["male", "female", "other", "not specified"];
  var DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
  var CUSTOMER_ID_MAX_ATTEMPTS = 24;
  var CUSTOMER_ID_RETRY_DELAY = 250;
  var FALLBACK_ENDPOINT =
    "https://delivery-options-postcode-production.up.railway.app/api/customer-profile/facts";

  var config = window.customerFactsProxy || {};
  var activePopupClose = null;

  var messages = {
    en: {
      birth_date_required: "Enter your birthday.",
      birth_date_invalid_format: "Birthday must use YYYY-MM-DD format.",
      birth_date_invalid: "Enter a valid birthday.",
      birth_date_future: "Birthday cannot be in the future.",
      birth_date_under_13: "Customer must be 13+ years old.",
      gender_invalid: "Choose a valid gender value.",
      customer_id_required: "Please sign in and try again.",
      birth_date_locked: "Birthday is already saved and can only be changed by a manager.",
      save_failed: "Could not save the data. Please try again."
    },
    uk: {
      birth_date_required: "Вкажіть дату народження.",
      birth_date_invalid_format: "Дата має бути у форматі YYYY-MM-DD.",
      birth_date_invalid: "Вкажіть коректну дату народження.",
      birth_date_future: "Дата народження не може бути в майбутньому.",
      birth_date_under_13: "Клієнту має бути 13+ років.",
      gender_invalid: "Оберіть коректне значення статі.",
      customer_id_required: "Увійдіть в акаунт і спробуйте ще раз.",
      birth_date_locked: "Дата народження вже збережена і може бути змінена тільки менеджером.",
      save_failed: "Не вдалося зберегти дані. Спробуйте ще раз."
    }
  };

  function currentLocale() {
    var locale = String(config.locale || "en").toLowerCase();
    return locale.indexOf("uk") === 0 ? "uk" : "en";
  }

  function message(key) {
    var dictionary = messages[currentLocale()] || messages.en;
    return dictionary[key] || messages.en[key] || key;
  }

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function storageRemove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {}
  }

  function popupShownKey(customerId) {
    return POPUP_SHOWN_KEY_PREFIX + customerId;
  }

  function hasPopupBeenShown(customerId) {
    return storageGet(popupShownKey(customerId)) === "true";
  }

  function markPopupShown(customerId) {
    storageSet(popupShownKey(customerId), "true");
  }

  function setState(status, extra) {
    window.__ttCustomerFactsState = Object.assign(
      {
        status: status,
        customerId: getCustomerId(),
        endpoint: endpoint()
      },
      extra || {}
    );
  }

  function normalizedCustomerId(value) {
    if (value === null || value === undefined) {
      return "";
    }

    var customerId = String(value).trim();
    return /^\d+$/.test(customerId) ? customerId : "";
  }

  function getCustomerId() {
    var analyticsCustomerId =
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.page &&
      window.ShopifyAnalytics.meta.page.customerId;
    var storefrontCustomerId = window.__st && window.__st.cid;
    var shopifyCustomerId =
      window.Shopify && window.Shopify.customer && window.Shopify.customer.id;

    return (
      normalizedCustomerId(config.customerId) ||
      normalizedCustomerId(analyticsCustomerId) ||
      normalizedCustomerId(storefrontCustomerId) ||
      normalizedCustomerId(shopifyCustomerId) ||
      normalizedCustomerId(storageGet(MANUAL_CUSTOMER_ID_KEY))
    );
  }

  function waitForCustomerId(callback, attempt) {
    var customerId = getCustomerId();
    if (customerId || attempt >= CUSTOMER_ID_MAX_ATTEMPTS) {
      callback(customerId);
      return;
    }

    window.setTimeout(function () {
      waitForCustomerId(callback, attempt + 1);
    }, CUSTOMER_ID_RETRY_DELAY);
  }

  function endpoint() {
    return config.endpoint || FALLBACK_ENDPOINT;
  }

  function todayAtMidnight() {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  function parseDate(value) {
    if (typeof value !== "string" || value.trim() === "") {
      return { value: null, error: "birth_date_required" };
    }

    var normalizedValue = value.trim();
    var match = normalizedValue.match(DATE_PATTERN);
    if (!match) {
      return { value: null, error: "birth_date_invalid_format" };
    }

    var year = Number(match[1]);
    var month = Number(match[2]);
    var day = Number(match[3]);
    var parsedDate = new Date(year, month - 1, day);
    var isRealDate =
      parsedDate.getFullYear() === year &&
      parsedDate.getMonth() === month - 1 &&
      parsedDate.getDate() === day;

    if (!isRealDate) {
      return { value: null, error: "birth_date_invalid" };
    }

    var today = todayAtMidnight();
    if (parsedDate > today) {
      return { value: null, error: "birth_date_future" };
    }

    var minimumAgeDate = new Date(
      today.getFullYear() - 13,
      today.getMonth(),
      today.getDate()
    );

    if (parsedDate > minimumAgeDate) {
      return { value: null, error: "birth_date_under_13" };
    }

    return { value: normalizedValue, error: null };
  }

  function allowedGender(value) {
    return typeof value === "string" && ALLOWED_GENDERS.indexOf(value.trim()) !== -1;
  }

  function parseGender(value) {
    if (!allowedGender(value)) {
      return { value: null, error: "gender_invalid" };
    }

    return { value: value.trim(), error: null };
  }

  function validateFacts(payload) {
    var birthDate = parseDate(payload.birthDate);
    if (birthDate.error) {
      return { ok: false, error: birthDate.error };
    }

    var gender = parseGender(payload.gender);
    if (gender.error) {
      return { ok: false, error: gender.error };
    }

    return {
      ok: true,
      payload: {
        birthDate: birthDate.value,
        gender: gender.value
      }
    };
  }

  function normalizeRemoteFacts(body) {
    var birthDate = body && typeof body.birthDate === "string" && body.birthDate
      ? body.birthDate
      : null;
    var gender = body && allowedGender(body.gender) ? body.gender.trim() : null;

    return {
      birthDate: birthDate,
      gender: gender,
      complete: Boolean(birthDate && gender)
    };
  }

  function applyFactsToConfig(facts) {
    config.birthDate = facts.birthDate || "";
    config.gender = facts.gender || "";
  }

  function parseResponse(response) {
    return response
      .json()
      .catch(function () {
        return null;
      })
      .then(function (body) {
        return {
          ok: response.ok,
          status: response.status,
          body: body
        };
      });
  }

  function getFacts(customerId) {
    var separator = endpoint().indexOf("?") === -1 ? "?" : "&";

    return fetch(endpoint() + separator + "customerId=" + encodeURIComponent(customerId), {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }).then(parseResponse);
  }

  function postFacts(customerId, payload) {
    return fetch(endpoint(), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        customerId: customerId,
        birthDate: payload.birthDate,
        gender: payload.gender
      })
    }).then(parseResponse);
  }

  function formErrorElement(form) {
    return form.querySelector("[data-customer-facts-error], .form-error");
  }

  function setFormError(form, error) {
    var errorElement = formErrorElement(form);
    if (errorElement) {
      errorElement.textContent = error ? message(error) : "";
    }
  }

  function setFormSubmitting(form, isSubmitting) {
    var buttons = form.querySelectorAll("button, input[type='submit'], input[type='button']");
    buttons.forEach(function (button) {
      button.disabled = isSubmitting;
    });
  }

  function factsFromForm(form) {
    var birthDateField = form.querySelector("[data-customer-facts-birth-date]");
    var genderField = form.querySelector("[data-customer-facts-gender]");

    return {
      birthDate: birthDateField ? birthDateField.value : config.birthDate,
      gender: genderField ? genderField.value : config.gender
    };
  }

  function storePendingFacts(payload) {
    return storageSet(
      STORAGE_KEY,
      JSON.stringify({
        birthDate: payload.birthDate,
        gender: payload.gender,
        createdAt: Date.now()
      })
    );
  }

  function readPendingFacts() {
    var rawPayload = storageGet(STORAGE_KEY);
    if (!rawPayload) {
      return null;
    }

    try {
      var parsedPayload = JSON.parse(rawPayload);
      return parsedPayload && typeof parsedPayload === "object" ? parsedPayload : null;
    } catch (error) {
      return null;
    }
  }

  function formFieldWrap(field) {
    return field ? field.closest(".login-input-wrap") : null;
  }

  function showField(field, shouldShow) {
    var wrap = formFieldWrap(field);
    if (wrap) {
      wrap.hidden = !shouldShow;
    }

    if (field) {
      field.required = shouldShow;
      field.disabled = false;
    }
  }

  function configureFormForFacts(form, facts) {
    var birthDateField = form.querySelector("[data-customer-facts-birth-date]");
    var genderField = form.querySelector("[data-customer-facts-gender]");

    if (birthDateField) {
      birthDateField.value = facts.birthDate || "";
      showField(birthDateField, !facts.birthDate);
    }

    if (genderField) {
      genderField.value = facts.gender || "";
      showField(genderField, !facts.birthDate || !facts.gender);
    }

    setFormError(form, "");
  }

  function closeActivePopup() {
    if (typeof activePopupClose === "function") {
      activePopupClose();
    }
  }

  function openPopup(form) {
    if (!form || activePopupClose) {
      return false;
    }

    var popupOverlay = document.createElement("div");
    var popupBox = document.createElement("div");
    var closeButton = document.createElement("button");
    var popupForm = form.cloneNode(true);

    popupOverlay.className = "form-popup-overlay";
    popupBox.className = "form-popup-box";
    closeButton.className = "form-popup-close";
    closeButton.type = "button";
    closeButton.setAttribute("aria-label", "Close");
    closeButton.textContent = "x";

    activePopupClose = function () {
      if (document.body.contains(popupOverlay)) {
        document.body.removeChild(popupOverlay);
      }

      activePopupClose = null;
    };

    closeButton.addEventListener("click", closeActivePopup);
    popupOverlay.addEventListener("click", function (event) {
      if (event.target === popupOverlay) {
        closeActivePopup();
      }
    });

    popupBox.appendChild(closeButton);
    popupBox.appendChild(popupForm);
    popupOverlay.appendChild(popupBox);
    document.body.appendChild(popupOverlay);
    return true;
  }

  function setupFactsPopup(facts, customerId) {
    var popup = document.querySelector("[data-customer-facts-popup]");
    if (!popup || facts.complete) {
      return false;
    }

    if (hasPopupBeenShown(customerId)) {
      return false;
    }

    var form = popup.querySelector("[data-customer-facts-form]");
    if (!form) {
      return false;
    }

    configureFormForFacts(form, facts);
    if (openPopup(form)) {
      markPopupShown(customerId);
      return true;
    }

    return false;
  }

  function isPopupForm(form) {
    return Boolean(form.closest(".form-popup-overlay"));
  }

  function bindRegistrationPendingStore() {
    document.addEventListener("theme:form-valid-submit", function (event) {
      var form = event.target;
      if (!form || !form.classList || !form.classList.contains("customer-facts-registration")) {
        return;
      }

      var validation = validateFacts(factsFromForm(form));
      if (!validation.ok) {
        setFormError(form, validation.error);
        event.preventDefault();
        return;
      }

      if (!storePendingFacts(validation.payload)) {
        setFormError(form, "save_failed");
        event.preventDefault();
      }
    });
  }

  function submitFactsForm(form) {
    var customerId = getCustomerId();
    if (!customerId) {
      setFormError(form, "customer_id_required");
      setState("customer_id_missing");
      return;
    }

    var validation = validateFacts(factsFromForm(form));
    if (!validation.ok) {
      setFormError(form, validation.error);
      return;
    }

    setFormError(form, "");
    setFormSubmitting(form, true);
    setState("saving");

    postFacts(customerId, validation.payload)
      .then(function (result) {
        if (!result.ok) {
          var error = result.body && result.body.error ? result.body.error : "save_failed";
          setFormError(form, error);
          setState("save_failed", { responseStatus: result.status, responseBody: result.body });
          return;
        }

        storageRemove(STORAGE_KEY);
        applyFactsToConfig(normalizeRemoteFacts(result.body || {}));
        setState("saved");

        if (isPopupForm(form)) {
          closeActivePopup();
        } else {
          window.location.reload();
        }
      })
      .catch(function (error) {
        setFormError(form, "save_failed");
        setState("save_failed", { error: String(error) });
      })
      .finally(function () {
        setFormSubmitting(form, false);
      });
  }

  function bindFactsForms() {
    document.addEventListener("submit", function (event) {
      var form = event.target && event.target.closest
        ? event.target.closest("[data-customer-facts-form]")
        : null;

      if (!form) {
        return;
      }

      event.preventDefault();
      submitFactsForm(form);
    });
  }

  function postPendingFacts(customerId, facts) {
    var pendingPayload = readPendingFacts();
    if (!pendingPayload) {
      return Promise.resolve(false);
    }

    var validation = validateFacts(pendingPayload);
    if (!validation.ok || (facts.birthDate && facts.gender)) {
      storageRemove(STORAGE_KEY);
      return Promise.resolve(false);
    }

    return postFacts(customerId, validation.payload)
      .then(function (result) {
        if (result.ok || result.status === 409) {
          storageRemove(STORAGE_KEY);
          return true;
        }

        if (result.status === 400) {
          storageRemove(STORAGE_KEY);
        }

        return false;
      })
      .catch(function () {
        return false;
      });
  }

  function initializeCustomerFactsFlow() {
    waitForCustomerId(function (customerId) {
      if (!customerId) {
        setState("customer_id_missing");
        return;
      }

      setState("loading");

      getFacts(customerId)
        .then(function (result) {
          if (!result.ok || !result.body) {
            setState("load_failed", {
              responseStatus: result.status,
              responseBody: result.body
            });
            return null;
          }

          var facts = normalizeRemoteFacts(result.body);
          applyFactsToConfig(facts);

          return postPendingFacts(customerId, facts).then(function (postedPending) {
            if (!postedPending) {
              return facts;
            }

            return getFacts(customerId).then(function (freshResult) {
              if (!freshResult.ok || !freshResult.body) {
                return facts;
              }

              var freshFacts = normalizeRemoteFacts(freshResult.body);
              applyFactsToConfig(freshFacts);
              return freshFacts;
            });
          });
        })
        .then(function (facts) {
          if (!facts) {
            return;
          }

          if (facts.complete) {
            setState("complete", { facts: facts });
            return;
          }

          if (setupFactsPopup(facts, customerId)) {
            setState("showing_popup", { facts: facts });
          } else {
            setState("popup_suppressed", { facts: facts });
          }
        })
        .catch(function (error) {
          setState("load_failed", { error: String(error) });
        });
    }, 0);
  }

  bindRegistrationPendingStore();
  window.__ttCustomerFactsRetry = initializeCustomerFactsFlow;

  document.addEventListener("DOMContentLoaded", function () {
    bindFactsForms();
    initializeCustomerFactsFlow();
  });
})();
